 
 
 
 
 
 
define(['leaflet'], function(L) {
    'use strict';
    function getValueOrEmptyString(value) {
        return value || '';
    }

    return function(address) {
        var addressElement = L.DomUtil.create('div'),
            streetElement = L.DomUtil.create('div', null, addressElement),
            municipalityElement = L.DomUtil.create('div', null, addressElement);

        streetElement.innerHTML = getValueOrEmptyString(address.streetName) + ' ' +
            getValueOrEmptyString(address.streetNumber);
        municipalityElement.innerHTML = getValueOrEmptyString(address.postalCode) + ' ' +
            getValueOrEmptyString(address.municipality);

        return addressElement;
    };
});



// WEBPACK FOOTER //
// ./services/popupContentGenerator/details/addressContainer.js